import Vue from 'vue';
// Vue.directive('scroll', { // Самописная директива v-scroll которая вешает обработчик скролла окна
//   inserted(el, binding) {
//     const f = function(evt) {
//       if (binding.value(evt, el) || !document.contains(el)) {
//         window.removeEventListener('scroll', f);
//         return;
//       }
//       binding.value(evt, el);
//     };
//     window.addEventListener('scroll', f);
//   },
// });
//

// Vue.directive('focus', {
//   // Когда привязанный элемент вставлен в DOM...
//   inserted: function(el) {
//     // Переключаем фокус на элемент
//     el.focus();
//   },
// });
Vue.directive('scroll-el', { // Самописная директива v-scroll которая вешает на елмент обработчик скролла елмента
  inserted(el, binding) {
    const f = function(evt) {
      if (binding.value(evt, el)) {
        el.removeEventListener('scroll', f, {passive: true});
        return;
      }
      binding.value(evt, el);
    };
    el.addEventListener('scroll', f, {passive: true});
  },
});
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // here I check that click was outside the el and his children
      if (!(el === event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind(el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});
